import 'owl.carousel';

const $ = window.jQuery;

class Carousel {
  constructor(element) {
    this.element = element;
  }

  init() {
    const carouselElement = $(this.element);

    this.carousel = $(carouselElement).owlCarousel({
      items: 1,
      nav: true,
      dots: true,
      autoplay: false,
      rewind: true,
      navText: [
        '<i class="fas fa-arrow-left"></i>',
        '<i class="fas fa-arrow-right"></i>',
      ],
      navContainer: '.owl-stage-outer',
    });

    if (carouselElement.find('img').length === 1) {
      carouselElement.addClass('one-image');
    }
  }
}

$(document).ready(() => {
  const elements = $('.image-carousel');

  if (elements.length) {
    elements.each((idx, element) => {
      const carousel = new Carousel(element);
      carousel.init();
    });
  }
});
